<div class="page-content-area" style="overflow-y: auto;">
  <div class="page-content-area__header">
    <div class="page-title-area">
      <div class="page-title-area__left-block">
        <h1 class="page-title">
          Báo cáo theo ngày
        </h1>
      </div>
    </div>
  </div>
  <div style="margin: 5px;">
    <p-toast />
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>
      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-3">
          <label for="TRANSPORTTYPEId">Đơn vị</label>
          <p-dropdown [options]="listUnit" [autoDisplayFirst]="false" dropdownIcon="ci ci-chevron-down-1" [virtualScroll]="true" [virtualScrollItemSize]="10"
            appendTo="body" [(ngModel)]="unitCode" formControlName="unitCode" [filter]="true" filterBy="label,value">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <label for="categoryId">Dịch vụ</label>
          <p-dropdown [options]="listCategory" [autoDisplayFirst]="false" dropdownIcon="ci ci-chevron-down-1"
            appendTo="body" [(ngModel)]="categoryId" formControlName="categoryId" [filter]="true" (onChange)="getListProduct()"
            filterBy="label,value">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <label for="productId">Sản phẩm</label>
          <p-dropdown [options]="listProduct" [autoDisplayFirst]="false" dropdownIcon="ci ci-chevron-down-1"
            appendTo="body" [(ngModel)]="productId" formControlName="productId" [filter]="true"
            filterBy="label,value">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-3"></div>
        <div class="field col-12 md:col-2">
          <p-checkbox [(ngModel)]="isDate" label="Từ ngày đến ngày" formControlName="isDate" name="date"
            style="margin-top: 25px;" (onChange)="selectDate()" [binary]="true" />
        </div>
        <div class="field col-12 md:col-1">
          <p-checkbox [(ngModel)]="isMonth" label="Tháng" (onChange)="selectMonth()" formControlName="isMonth"
            style="margin-top: 25px;" name="month" [binary]="true" />
        </div>
        <div *ngIf="isDate" class="field col-12 md:col-3">
          <label for="">Từ ngày</label>
          <p-calendar formControlName="fromDate" [(ngModel)]="fromDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" />
        </div>
        <div *ngIf="isDate" class="field col-12 md:col-3">
          <label for="">Đến ngày</label>
          <p-calendar formControlName="toDate" [(ngModel)]="toDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" [minDate]="fromDate" />
        </div>
        <div *ngIf="isMonth" class="field col-12 md:col-3">
          <label for="">Tháng</label>
          <p-calendar [(ngModel)]="month" formControlName="toDate" view="month" dateFormat="mm/yy" icon="ci ci-calendar" placeholder="mm/yyyy"
            />
        </div>
        <div *ngIf="isMonth" class="field col-12 md:col-3">
        </div>

        <div class="field col-12 md:col-1 ">
          <p-button [outlined]="true" (click)="search()" authorize="[{'llbapi':'report/1'}]"
            [style]="{'margin-top': '25px','max-width':'100%','max-height':'50%', 'text-align':'center'}"
            icon="pi pi-search" label="Lọc"></p-button>
        </div>
        <div class="field col-12 md:col-1">
          <p-button [outlined]="true" (click)="exportExcel()" authorize="[{'llbapi':'report/1'}]"
            [style]="{'margin-top': '25px','width':'100%','max-height':'50%', 'text-align':'center', 'float':'right'}"
            icon="pi pi-file-excel" label="Export excel"></p-button>
        </div>
      </div>
    </form>
  </div>
  <div class="body" style="margin: 5px;">
    <div class="data-view-main-action-area__left-block" style="flex: 1; min-width: 110px">
      Tổng số sản lượng: <b>{{sumInfo.saleRecordsQuantity | number : '1.2-2'}}</b> &nbsp; -
      Tổng doanh số bán: <b>{{sumInfo.salesNumber | number : '1.2-2'}}</b> &nbsp; -
      Tổng doanh thu: <b>{{sumInfo.revenue | number : '1.2-2'}}</b> &nbsp;
      Tổng thù lao: <b>{{sumInfo.totalRemuneration | number : '1.2-2'}}</b> &nbsp;
      Tổng thù lao được nhận: <b>{{sumInfo.remunerationReceived | number : '1.2-2'}}</b> &nbsp;
    </div>
    <div class="data-view-main-action-area__right-block">
      <div class="h-mb-8">
        {{(pageIndex -1) * pageSize + 1}} - {{pageIndex * pageSize}} {{'LIST.OFF' | translate}}
        {{totalRecord}}
      </div>
      <button pButton pRipple type="button" icon="pi pi-angle-left" (click)="onPrePage()" [disabled]="pageIndex == 1"
        class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <button pButton pRipple type="button" icon="pi pi-angle-right" (click)="onNextPage()"
        [disabled]="pageIndex > totalRecord / pageSize" class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <button pButton pRipple type="button" icon="ci ci-data-1" (click)="visibleCols.toggle($event)"
        class="p-button-rounded p-button-text mr-2 mb-2"></button>
      <p-overlayPanel #visibleCols [hideTransitionOptions]="'0ms'" [showTransitionOptions]="'0ms'" appendTo="body"
        styleClass="ag-overlay-menu style-2">
        <div class="ag-overlay-menu__title">
          <span (click)="resetColsVisibility()" class="ag-overlay-menu__clear-btn">
            {{getVisibleColsNumber()}}
            <span class="ag-overlay-menu__clear-icon ci ci-close"></span>
          </span>

          <span class="__text">
            {{'LIST.COLS_SELECTED' | translate}}
          </span>
        </div>

        <div *ngFor="let col of cols" [class.-activated]="col.visible" class="ag-overlay-menu__item-wrapper">
          <div class="ag-overlay-menu__item">

          </div>
        </div>
      </p-overlayPanel>
    </div>
    <div class="table-wrapper setpading">
      <!--  class="ag-table -status-style-border-left" -->
      <p-table [columns]="cols" [value]="dataSource" [rows]="pageSize" [totalRecords]="totalRecord" [customSort]="true"
        [scrollHeight]="'80vh'" [scrollable]="true" (onSort)="onSort($event)" (onPage)="onPage($event)"
        [tableStyle]="{ 'min-width': setWidth, 'width': 'auto !important' }" [loading]="isLoading" [lazy]="true"
        styleClass="p-datatable-gridlines">

        <ng-template pTemplate="colgroup">
          <colgroup>
            <ng-container *ngFor="let col of cols">
              <col [style.width]="col.width ? col.width : 'auto'" [hidden]="!col.visible" />
            </ng-container>
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.sort" [hidden]="!col.visible" [pSortableColumn]="col.field">
                <div class="h-flex-el -h-space-between">
                  <div class="h-overflow-break-word">{{ col.header }}</div>
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
              </th>

              <th *ngIf="!col.sort" [hidden]="!col.visible">
                <div class="h-overflow-break-word">{{ col.header }}</div>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [class.ag-tr-status]="rowData.status" [class.ag-tr-status-danger]="rowData.status === 3"
            [class.ag-tr-status-warning]="rowData.status === 2" [class.ag-tr-status-success]="rowData.status === 1">
            <td *ngFor="let col of columns" [hidden]="!col.visible" [ngSwitch]="col.field">
              <span *ngSwitchCase="'salesDate'"> {{ rowData.salesDate || 'dd-MM-yyyy' }}</span>
              <span *ngSwitchDefault>{{ rowData[col.field] }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>